import dayjs from "dayjs";
import ThunderIcon from "@/assets/icons/thunder.svg";
import ThunderDisabledIcon from "@/assets/icons/thunder_disabled.svg";
import EnterpriseIcon from "@/assets/icons/enterprise_icon.svg";
import styles from "../../styles.module.scss";

const TimelineEventIconWithDate = (eventType: string, eventTime: string) => {
  const isoDatetime = new Date(eventTime).toISOString();
  const formattedDatetime = dayjs(isoDatetime).format("hh:mm A, MMM DD, YYYY");
  switch (eventType) {
    case "auto_tune_enabled":
      return (
        <>
          <img src={ThunderIcon} alt="" />
          <div className={styles.timeline_event_icon}>{formattedDatetime}</div>
        </>
      );
    case "auto_tune_disabled":
      return (
        <>
          <img src={ThunderDisabledIcon} alt="" />
          <div className={styles.timeline_event_icon}>{formattedDatetime}</div>
        </>
      );
    default:
      return (
        <>
          <img src={EnterpriseIcon} alt="" />
          <div className={styles.timeline_event_icon}>{formattedDatetime}</div>
        </>
      );
  }
};

export default TimelineEventIconWithDate;